<script>
	import { Table, DropdownItem } from "@sveltestrap/sveltestrap";
	import Pagination from "../../../components/CustomPaginate/Pagination.svelte";
	import CustomModal from "../../../components/CustomModal/CustomModal.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { navigate } from "svelte-routing";
	import TableDropdown from "../../../components/TableDropdown/TableDropdown.svelte";

	export let handleInactive;
	export let data;
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>Email</th>
				<th>Password</th>
				<th>EV Charging Company</th>
				<th>Car Plate Number</th>
				<th>Status</th>
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { id, status, email, password, evCompany, carPlateNumber }}
				<tr>
					<td>
						<!-- svelte-ignore a11y-click-events-have-key-events -->
						<p
							class="link"
							on:click={() => {
								navigate(`ev-account-management/edit?id=${id}`);
							}}
						>
							<span class="link link-text"> {email} </span>
						</p>
					</td>
					<td>
						<p>{"*".repeat(password.length)}</p>
					</td>
					<td>
						<p>
							<span> {evCompany} </span>
						</p>
					</td>
					<td>
						<p>
							<span> {carPlateNumber} </span>
						</p>
					</td>
					<td>
						{#if status === true}
							<p class="status-bar status-bar-1">Active</p>
						{:else if status === false}
							<p class="status-bar status-bar-3">Inactive</p>
						{/if}
					</td>
					<td>
						<TableDropdown>
							<DropdownItem
								on:click={() => {
									navigate(
										`ev-account-management/edit?id=${id}`
									);
								}}>Edit Details</DropdownItem
							>
							{#if status}
								<DropdownItem
									on:click={() => handleInactive(id, status)}
									>Set as Inactive</DropdownItem
								>
							{:else if !status}
								<DropdownItem
									on:click={() => handleInactive(id, status)}
									>Set as Active</DropdownItem
								>
							{/if}
						</TableDropdown>
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.totalCount == 0 || !data.totalCount}
		<p class="text-center">No data to display</p>
	{/if}
	<Pagination totalRecord={data.totalCount || 0} />
	<CustomModal />
</LoaderContainer>
